import { CallingStatusValues } from '@/constants/callingStatus';
import { SupporterList } from '@/types';

export type CallingNavigationIndices = {
  previousIndex: number | null;
  previousStatus: string | null;
  nextIndex: number | null;
  nextStatus: string | null;
  nextUncheckedIndex: number | null;
};

const emptyIndices: CallingNavigationIndices = {
  previousIndex: null,
  previousStatus: null,
  nextIndex: null,
  nextStatus: null,
  nextUncheckedIndex: null,
};

export function computeCallingNavigationIndices({
  list,
  callingViewContactIndex,
  callingViewContactIndexMod,
  callingViewContactIndexRmd,
  pageNo,
  viewContactedChecked,
}: {
  list: SupporterList | undefined;
  callingViewContactIndex: number;
  callingViewContactIndexMod: number | null;
  callingViewContactIndexRmd: number | null;
  pageNo: number;
  viewContactedChecked: boolean;
}): CallingNavigationIndices {
  if (
    !list ||
    pageNo * list.limit !== callingViewContactIndexRmd ||
    callingViewContactIndexMod === null ||
    callingViewContactIndexRmd === null
  ) {
    return emptyIndices;
  }

  let previousIndex: number | null = null;
  let previousStatus: string | null = null;
  let nextIndex: number | null = null;
  let nextStatus: string | null = null;
  let nextUncheckedIndex: number | null = null;

  if (callingViewContactIndex > 0) {
    if (callingViewContactIndexMod === 0) {
      if (viewContactedChecked) {
        previousIndex = callingViewContactIndex - 1;
        previousStatus = list.previousCallingStatus;
      } else {
        previousIndex = list.previousUncalledIndex;
        previousStatus = CallingStatusValues[0];
      }
    } else {
      if (viewContactedChecked) {
        previousIndex = callingViewContactIndex - 1;
        previousStatus = list.contactRecords[callingViewContactIndexMod - 1].callingStatus;
      } else {
        previousStatus = CallingStatusValues[0];
        for (let i = callingViewContactIndexMod - 1; i >= 0; i--) {
          if (list.contactRecords[i].callingStatus === CallingStatusValues[0]) {
            previousIndex = i + callingViewContactIndexRmd;
            break;
          }
        }
        if (previousIndex === null) {
          previousIndex = list.previousUncalledIndex;
        }
      }
    }
  }

  if (callingViewContactIndex < list.count - 1) {
    if (callingViewContactIndexMod === list.limit - 1) {
      if (viewContactedChecked) {
        nextIndex = callingViewContactIndex + 1;
        nextStatus = list.nextCallingStatus;
      } else {
        nextIndex = list.nextUncalledIndex;
        nextStatus = CallingStatusValues[0];
      }
      nextUncheckedIndex = list.nextUncalledIndex;
    } else {
      for (let i = callingViewContactIndexMod + 1; i < list.contactRecords.length; i++) {
        if (list.contactRecords[i].callingStatus === CallingStatusValues[0]) {
          nextUncheckedIndex = i + callingViewContactIndexRmd;
          break;
        }
      }
      if (nextUncheckedIndex === null) {
        nextUncheckedIndex = list.nextUncalledIndex;
      }

      if (viewContactedChecked) {
        nextIndex = callingViewContactIndex + 1;
        nextStatus = list.contactRecords[callingViewContactIndexMod + 1].callingStatus;
      } else {
        nextStatus = CallingStatusValues[0];
        nextIndex = nextUncheckedIndex;
      }
    }
  }

  return {
    previousIndex,
    previousStatus,
    nextIndex,
    nextStatus,
    nextUncheckedIndex,
  };
}
